import { useState } from "react";
import PlayCircleRoundedIcon from "@mui/icons-material/PlayCircleRounded";
import "react-h5-audio-player/lib/styles.css";
import PlayerOverlay from "./PlayerOverlay";
import useFetch from "../../hooks/useFetch";

import { formatSongTitle } from "./formatSongTitle";

function PlayAction({ item }: any) {

  const [open, setOpen] = useState(false);
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);

  const { fetchData: fetchSignedUrl } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/events/music/signedurl/${item.id}`,
    method: "POST",
  });

  const handlePlayClick = async () => {
    try {
      console.log("PlayAction: Fetching fresh playback URL");

      const response = await fetchSignedUrl({ song_id: item.id, s3_file_key: item.s3_file_key, action:"Playback"});
      const playbackUrl = response?.data?.s3playbackurl;

      if (!playbackUrl) {
        console.error("PlayAction: No playback URL returned");
        return;
      }

      setCurrentUrl(playbackUrl);
      setOpen(true);
    } catch (error) {
      console.error("PlayAction: Failed to get playback URL", error);
    }
  };

  if (!item.s3_file_key) return null;

  return (
    <>
      <PlayCircleRoundedIcon
        className="music-icon play"
        onClick={handlePlayClick}
        titleAccess="Play"
        sx={{ cursor: "pointer", color: "#1976d2" }}
      />

      {open && currentUrl && (
        <PlayerOverlay
          url={currentUrl}
          title={formatSongTitle(item.song_title, item.performance?.entry_number ?? 0)}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}

export default PlayAction;